import LinkElement from './LinkElement.component';

export default LinkElement;